import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { interceptAttributesWithDefaults } from "flow/koHelpers/interceptAttributes";
import { selectPlaceholder } from "flow/koHelpers/selectParam";
import ko from "knockout";
import { IDateParams } from "./date";
import viewHtml from "./dateLite.html";

export interface IDateLiteParams extends IDateParams {
    validationErrorClass?: string;
    daysAfterStartDate?: number;
}

ko.components.register("ko-date-lite", {
    viewModel: function (params: IDateLiteParams) {
        this.value = params.value;
        this.valueUpdate = params.valueUpdate;
        this.datepickerOptions = params.datepickerOptions || {};
        this.enable = createEnabler(params.enable, params.disable);
        this.preventBubble = params.preventBubble || "";
        this.validationErrorClass = params.validationErrorClass ? params.validationErrorClass : "";
        this.cssObj = {};
        this.daysAfterStartDate = params.daysAfterStartDate ? params.daysAfterStartDate : null;

        if (!!this.validationErrorClass && params.value.isValid) {
            this.cssObj[this.validationErrorClass] = ko.pureComputed(function () {
                return params.value.isValid() === false;
            });
        }

        this.attributes = interceptAttributesWithDefaults(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
